<template>
  <el-dialog
    class="goal-category-config-modal"
    top="8vh"
    :visible.sync="dialog_visible"
    :fullscreen="false"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :show-close="true"
    title="Create a new goal category"
    @close="onResetForm">

    <el-form size="fat" label-position="top" @submit.native.prevent>

      <div style="display: flex; justify-content: space-between;">
        <el-form-item label="Please select a category" class="mr-6">
          <div class="mx-auto" style="width: 400px">
            <wheel-of-life
              :areas="areas"
              v-model="categoryForm.categoryKey"
              @input="onSelectCategory" />
          </div>
        </el-form-item>

        <el-form-item label="Select a default schedule (optional)">
          <el-radio-group
            class="timeslot-collection-radio-group"
            v-model="categoryForm.defaultTimeslotCollectionId">
            <el-radio
              v-for="item in timeslotCollectionsSelectOptions"
              :key="item.value"
              :label="item.value"
              :style="{ width: '100%', color: item.color }">
              {{item.label}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <el-form-item label="Short description or name">
        <el-input size="fat" v-model="categoryForm.name" placeholder="Category name" autofocus></el-input>
      </el-form-item>

      <info-box title="Title">
        Text text text.
      </info-box>

      <div class="wizard-buttons pt-2">
        <el-button size="fat" @click="onResetForm">Cancel</el-button>
        <el-button size="fat" @click="onClickDone" type="primary" style="float: right;">Create</el-button>
      </div>

      <pre class="mini-pre" v-if="SHOW_DEBUG">{{categoryForm.$state}}</pre>

    </el-form>
  </el-dialog>
</template>

<script>
import WheelOfLife from '@/components/Elements/Charts/WheelOfLife'

// TODO: Show number of existing goals for each area

export default {
  data: () => ({
    dialog_visible: false,
    categoryForm: {},
  }),
  computed: {
    timeslot_collection_list() {
      return this.$models.timeslotCollection.getList().itemsAsArray();
    },
    timeslotCollectionsSelectOptions() {
      let timeslotCollectionList = this.timeslot_collection_list.map(item => {
        return { value: item.$id, label: item.name, color: item.color }
      });
      // Don't show blocker?
      let neverEntry = { value: null, label: "<No default schedule>", color: '#888888' };
      return [ ...timeslotCollectionList, neverEntry ];
    },
    areas() {
      return this.$models.userGoalCategory.modelDefinition.categoryKeys;
    },
  },
  methods: {
    showNewModal() {
      this.dialog_visible = true;

      this.categoryForm = this.$models.userGoalCategory
        .new_from_template({})
        .clone()
    },

    showUpdateModal({ category_id }) {
      this.dialog_visible = true;

      this.categoryForm = this.$models.userGoalCategory
        .getNode( category_id )
        .clone();
    },

    onResetForm() {
      this.dialog_visible = false;
      this.categoryForm = {}
    },

    onSelectCategory(id) {
      console.log("onSelectCategory", id)
      let item = this.areas.find(item => item.id === id);
      if ( item ) {
        this.categoryForm.name = item.text;
      }
    },

    onDone() {
      this.$emit('done')
      this.onResetForm();
    },

    onClickDone() {

      // TODO: Set sortidx
      // this.categoryForm.sortidx = 100;

      this.categoryForm.write().then(commitment_id => {
        this.$emit('saved', this.categoryForm);
        this.onDone();
      });
    },
  },
  components: {
    WheelOfLife
  }
}
</script>

<style>
.goal-category-config-modal {
}
</style>
